<nav [class.toggle]="toggle">

  <div>
    <a [href]="data.logoURL" target="_blank">
      <lib-logo [variant]="toggle ? 'icon' : 'wordmark'" theme="reverse"></lib-logo>
    </a>
    <button [ngSwitch]="toggle" type="button" class="lib-button" pTrackEvent="click" pTrackAction="my_home"
      pTrackCategory="app_menu_toggle" (click)="toggle = !toggle">
      <lib-icon *ngSwitchDefault name="chevronLeft"></lib-icon>
      <lib-icon *ngSwitchCase="true" name="chevronRight"></lib-icon>
    </button>
  </div>

  <ul>

    <span class="lib-spacer desktop-only"></span>

    <li class="first-child">

      <button type="button" class="lib-button" routerLinkActive="active" routerLink=""
        [routerLinkActiveOptions]="{exact: true}" pTrackEvent="click" pTrackAction="my_home" pTrackCategory="app_menu">
        <lib-icon name="home"></lib-icon>
        <span> My home</span>
      </button>

    </li>

    <li *ngIf="data.onboarded && data.qualified && data.step > 0">
      <button type="button" class="lib-button" routerLinkActive="active" routerLink="/homes" pTrackEvent="click"
        pTrackAction="browse_homes" pTrackCategory="app_menu">
        <lib-icon name="search"></lib-icon>
        <span> Browse homes</span>
      </button>
    </li>

    <li *ngIf="data.onboarded && data.qualified && data.step > 0">
      <button type="button" class="lib-button-flat-primary" (click)="onAddHomeClick()" pTrackEvent="click" pTrackAction="add_home"
        pTrackCategory="app_menu" data-test="add-home-button">
        <lib-icon name="plus"></lib-icon>
        <span>Add home</span>
      </button>
    </li>

    <li *ngIf="data.onboarded && data.qualified && data.step > 0">
      <button type="button" class="lib-button" routerLinkActive="active" routerLink="/favourites"
        pTrackEvent="click" pTrackAction="favourites" pTrackCategory="app_menu">
        <lib-icon name="heart"></lib-icon>
        <span>Favourites</span>
        <div class="lib-badge" *ngIf="data.favouritesCount">
          <span>{{ data.favouritesCount }}</span>
        </div>
      </button>
    </li>

    <li *ngIf="data.onboarded && !data.qualified">
      <button type="button" class="lib-button-flat-primary" (click)="onStartOverClick()" data-test="start-over">
        <lib-icon name="start-over"></lib-icon>
        <span>Start over</span>
      </button>
    </li>

    <li *ngIf="data.onboarded && data.qualified && data.step === 0">
      <app-mip-button [class.toggle]="toggle" signedInText="Download MIP" signedOutText="Get MIP"
        [disabled]="data.toggle.downloadingMip" (change)="data.toggle.downloadingMip = $event" data-test="download-mip">
      </app-mip-button>
    </li>

    <li *ngIf="!data.onboarded">
      <button class="lib-button-flat-primary mobile-sticky" routerLink="/" fragment="get-started" data-test="get-started-button">
        <lib-icon name="calculator"></lib-icon>
        <span>Get started</span>
      </button>
    </li>

    <span class="lib-spacer-x3 desktop-only"></span>

    <li *ngIf="data.signedIn" class="last-child">
      <button class="lib-button-stroked" routerLinkActive="active" routerLink="/profile" pTrackEvent="click"
        pTrackAction="profile" pTrackCategory="app_profile">
        <lib-icon name="profile"></lib-icon>
        <span>Profile</span>
        <div class="lib-badge" *ngIf="data.profileComplete">
          <span>{{data.profileComplete | percent}}</span>
        </div>
      </button>
    </li>

    <li *ngIf="!data.signedIn" class="last-child">
      <button class="lib-button-stroked" routerLinkActive="active" routerLink="/signin" pTrackEvent="click"
        pTrackAction="signin" pTrackCategory="app_profile">
        <lib-icon name="profile"></lib-icon>
        <span>Sign in</span>
      </button>
    </li>

  </ul>

</nav>